import sortBy from 'lodash/sortBy';
import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const preventativeCareSelector = (state: RootState) => state.preventativeCare;

export const preventativeCareDataSelector = createSelector(preventativeCareSelector, pc => {
  return sortBy(pc.data, ['status', 'displayText']);
});

export const preventativeCareFetchingSelector = createSelector(
  preventativeCareSelector,
  pc => pc.isFetching
);

export const preventativeCareErrorSelector = createSelector(
  preventativeCareSelector,
  pc => pc.error
);

export const preventiveCareRequestStateSelector = createSelector(
  preventativeCareSelector,
  pc => pc.requestState
);
